// Cart
export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const UPDATE_CART_IS_FETCHING = 'UPDATE_CART_IS_FETCHING';

// Catalog
export const CATALOG_BEGIN_SEARCH = 'CATALOG_BEGIN_SEARCH';
export const CATALOG_RECEIVED_SEARCH_RESULTS =
  'CATALOG_RECEIVED_SEARCH_RESULTS';
export const CATALOG_SEARCH_ERROR = 'CATALOG_SEARCH_ERROR';
export const CATALOG_FILTER_DATA_ITEM = 'CATALOG_FILTER_DATA_ITEM';
export const CATALOG_FILTER_SHOP_ITEM = 'CATALOG_FILTER_SHOP_ITEM';
export const CATALOG_FILTER_SHOP_ITEM_CATEGORY =
  'CATALOG_FILTER_SHOP_ITEM_CATEGORY';
export const CATALOG_RESET_FOCUS = 'CATALOG_RESET_FOCUS';
export const CATALOG_USER_INITIATE_SEARCH = 'CATALOG_USER_INITIATE_SEARCH';

// Pagination
export const PAGINATION_CREATE = 'PAGINATION_CREATE';
export const PAGINATION_DELETE = 'PAGINATION_DELETE';
export const PAGINATION_SET_SIZE = 'PAGINATION_SET_SIZE';
export const PAGINATION_JUMP_TO_PAGE = 'PAGINATION_JUMP_TO_PAGE';

// FAQ
export const FAQ_FETCH_ERROR = 'FAQ_FETCH_ERROR';
export const FAQ_RECEIVED = 'FAQ_RECEIVED';

// Plan (Recurring/One-time)
export const PLAN_SELECT = 'PLAN_SELECT';
export const PLAN_CALCULATE = 'PLAN_CALCULATE';
export const PLAN_RECEIVED_PRICING = 'PLAN_RECEIVED_PRICING';
export const PLAN_FETCH_PLAN_PRICING = 'PLAN_FETCH_PLAN_PRICING';
export const PLAN_FETCH_PLAN_PRICING_ERROR = 'PLAN_FETCH_PLAN_PRICING_ERROR';

// User's Shop Items
export const USER_SHOP_ITEM_START_FETCH_PURCHASED =
  'USER_SHOP_ITEM_START_FETCH_PURCHASED';
export const USER_SHOP_ITEM_ERROR_FETCH_PURCHASED =
  'USER_SHOP_ITEM_ERROR_FETCH_PURCHASED';
export const USER_SHOP_ITEM_RECEIVED_PURCHASED =
  'USER_SHOP_ITEM_RECEIVED_PURCHASED';
export const USER_SHOP_ITEM_START_FETCH_ALL = 'USER_SHOP_ITEM_START_FETCH_ALL';
export const USER_SHOP_ITEM_ERROR_FETCH_ALL = 'USER_SHOP_ITEM_ERROR_FETCH_ALL';
export const USER_SHOP_ITEM_RECEIVED_ALL = 'USER_SHOP_ITEM_RECEIVED_ALL';

// Shop
export const SHOP_ITEM_ADD = 'SHOP_ITEM_ADD';
export const SHOP_ITEM_BUY = 'SHOP_ITEM_BUY';
export const SHOP_ITEM_BUY_UPDATE_STATE = 'SHOP_ITEM_BUY_UPDATE_STATE';
export const SHOP_ITEM_SELECT = 'SHOP_ITEM_SELECT';

// favourite
export const FAVOURITE_SEARCH_BEGIN = 'FAVOURITE_SEARCH_BEGIN';
export const FAVOURITE_SEARCH_ERROR = 'FAVOURITE_SEARCH_ERROR';
export const FAVOURITE_FETCH = 'FAVOURITE_FETCH';
export const FAVOURITE_ADD_TO = 'FAVOURITE_ADD_TO';
export const FAVOURITE_REMOVE_FROM = 'FAVOURITE_REMOVE_FROM';
export const FAVOURITE_DATA_ITEM_VIEW = 'FAVOURITE_DATA_ITEM_VIEW';
export const FAVOURITE_DATA_ITEM_PRICES = 'FAVOURITE_DATA_ITEM_PRICES';
export const FAVOURITE_UPDATE_STATE = 'FAVOURITE_UPDATE_STATE';
export const FAVOURITE_TOGGLE_EDIT_SETTINGS = 'FAVOURITE_TOGGLE_EDIT_SETTINGS';
export const FAVOURITE_SEARCH_PRODUCT = 'FAVOURITE_SEARCH_PRODUCT';
export const FAVOURITE_UPDATE_DATA_ITEM_TOTAL =
  'FAVOURITE_UPDATE_DATA_ITEM_TOTAL';
export const FAVOURITE_UPDATE_SHOP_ITEM_TOTAL =
  'FAVOURITE_UPDATE_SHOP_ITEM_TOTAL';
export const FAVOURITE_OPEN_SHOP_ITEM_INFO = 'FAVOURITE_OPEN_SHOP_ITEM_INFO';
export const FAVOURITE_OPEN_DATA_ITEM_INFO = 'FAVOURITE_OPEN_DATA_ITEM_INFO';
export const FAVOURITE_ADD_DATA_ITEMS = 'FAVOURITE_ADD_DATA_ITEMS';
export const FAVOURITE_ADD_SHOP_ITEMS = 'FAVOURITE_ADD_SHOP_ITEMS';
export const FAVOURITE_CLEAR_DATA_ITEMS = 'FAVOURITE_CLEAR_DATA_ITEMS';
export const FAVOURITE_CLEAR_SHOP_ITEMS = 'FAVOURITE_CLEAR_SHOP_ITEMS';
export const FAVOURITE_ADD_DATA_ITEMS_TO_COMPARE_PRICE =
  'FAVOURITE_ADD_DATA_ITEMS_TO_COMPARE_PRICE';
export const FAVOURITE_REMOVE_DATA_ITEMS_TO_COMPARE_PRICE =
  'FAVOURITE_REMOVE_DATA_ITEMS_TO_COMPARE_PRICE';
export const FAVOURITE_UPDATE_COMPARE_PRICE_FILTERS =
  'FAVOURITE_UPDATE_COMPARE_PRICE_FILTERS';
export const FAVOURITE_OPEN_TRADE_FORM_DRAWER =
  'FAVOURITE_OPEN_TRADE_FORM_DRAWER';
export const FAVOURITE_UPDATE_REFERENCE_YEAR =
  'FAVOURITE_UPDATE_REFERENCE_YEAR';
export const FAVOURITE_UPDATE_REFERENCE_PRICE =
  'FAVOURITE_UPDATE_REFERENCE_PRICE';
export const FAVOURITE_UPDATE_REFERENCE_PRODUCT =
  'FAVOURITE_UPDATE_REFERENCE_PRODUCT';
// FreeTrial
export const FREE_TRIAL_SHOW = 'FREE_TRIAL_SHOW';
export const FREE_TRIAL_IS_START = 'FREE_TRIAL_IS_START';

// Entities
export const ENTITIES_SET_USER_FAVOURITE_TAGS =
  'ENTITIES_GET_USER_FAVOURITE_TAGS';

// Payment
export const PAYMENT_SET_PUBLIC_BRAINTREE_TOKEN =
  'PAYMENT_SET_PUBLIC_BRAINTREE_TOKEN';
export const PAYMENT_SET_BRAINTREE_DROPIN_INSTANCE =
  'PAYMENT_SET_BRAINTREE_DROPIN_INSTANCE';

export const PAYMENT_SET_METHOD = 'PAYMENT_SET_METHOD';
export const PAYMENT_SET_USER_INFO = 'PAYMENT_SET_USER_INFO';
export const PAYMENT_SET_BILLING_INFO = 'PAYMENT_SET_BILLING_INFO';
export const PAYMENT_SET_CAPTCHA = 'PAYMENT_SET_CAPTCHA';
export const PAYMENT_SET_INFO = 'PAYMENT_SET_INFO';
export const PAYMENT_SET_RESPONSE = 'PAYMENT_SET_RESPONSE';
export const PAYMENT_SET_SUBMIT_BUTTON_DISABLED =
  'PAYMENT_SET_SUBMIT_BUTTON_DISABLED';
export const PAYMENT_SET_SUBMIT_BUTTON_LOADING =
  'PAYMENT_SET_SUBMIT_BUTTON_LOADING';

// Data Interest Form
export const DATA_INTEREST_FORM_SET_STEP = 'DATA_INTEREST_FORM_SET_STEP';
export const DATA_INTEREST_FORM_SET_STEP1_RESPONSE =
  'DATA_INTEREST_FORM_SET_STEP1_RESPONSE';
export const DATA_INTEREST_FORM_SET_STEP2_RESPONSE =
  'DATA_INTEREST_FORM_SET_STEP2_RESPONSE';
export const DATA_INTEREST_FORM_SET_STEP1_TAGS_SELECTED =
  'DATA_INTEREST_FORM_SET_STEP1_TAGS_SELECTED';
export const DATA_INTEREST_FORM_SET_STEP1_TAGS_DESELECTED =
  'DATA_INTEREST_FORM_SET_STEP1_TAGS_DESELECTED';
export const DATA_INTEREST_FORM_SET_STEP2_TAGS_SELECTED =
  'DATA_INTEREST_FORM_SET_STEP2_TAGS_SELECTED';
export const DATA_INTEREST_FORM_SET_STEP2_TAGS_DESELECTED =
  'DATA_INTEREST_FORM_SET_STEP2_TAGS_DESELECTED';
export const DATA_INTEREST_FORM_SET_STEP3_TAGS_SELECTED =
  'DATA_INTEREST_FORM_SET_STEP3_TAGS_SELECTED';
export const DATA_INTEREST_FORM_SET_STEP3_TAGS_DESELECTED =
  'DATA_INTEREST_FORM_SET_STEP3_TAGS_DESELECTED';
export const DATA_INTEREST_FORM_RESET_STEP_TAGS_SELECTED =
  'DATA_INTEREST_FORM_RESET_STEP_TAGS_SELECTED';
export const DATA_INTEREST_FORM_SET_TITLE = 'DATA_INTEREST_FORM_SET_TITLE';
export const DATA_INTEREST_FORM_SET_DESIGNATION =
  'DATA_INTEREST_FORM_SET_DESIGNATION';
export const DATA_INTEREST_FORM_SET_DIAL_CODE =
  'DATA_INTEREST_FORM_SET_DIAL_CODE';
export const DATA_INTEREST_FORM_SET_FULLNAME =
  'DATA_INTEREST_FORM_SET_FULLNAME';
export const DATA_INTEREST_FORM_SET_PHONE_NUMBER =
  'DATA_INTEREST_FORM_SET_PHONE_NUMBER';
export const DATA_INTEREST_FORM_SET_EMAIL = 'DATA_INTEREST_FORM_SET_EMAIL';
export const DATA_INTEREST_FORM_SET_COMPANY = 'DATA_INTEREST_FORM_SET_COMPANY';
export const DATA_INTEREST_FORM_SET_TYPE_OF_DATA =
  'DATA_INTEREST_FORM_SET_TYPE_OF_DATA';
export const DATA_INTEREST_FORM_SET_TYPE_OF_DATA_DESELECTED =
  'DATA_INTEREST_FORM_SET_TYPE_OF_DATA_DESELECTED';
export const DATA_INTEREST_FORM_SET_PLATFORMS =
  'DATA_INTEREST_FORM_SET_PLATFORMS';
export const DATA_INTEREST_FORM_SET_PLATFORMS_DESELECTED =
  'DATA_INTEREST_FORM_SET_PLATFORMS_DESELECTED';
export const DATA_INTEREST_FORM_SET_ADDITIONAL_INFO =
  'DATA_INTEREST_FORM_SET_ADDITIONAL_INFO';
export const DATA_INTEREST_FORM_SET_ID = 'DATA_INTEREST_FORM_SET_ID';
export const DATA_INTEREST_FORM_SET_STEP1_CACHE =
  'DATA_INTEREST_FORM_SET_STEP1_CACHE';
export const DATA_INTEREST_FORM_SET_SHOULD_SHOW_REQUEST_SUBMITTED_POPUP =
  'DATA_INTEREST_FORM_SET_SHOULD_SHOW_REQUEST_SUBMITTED_POPUP';

// NewsFeed
export const NEWS_FEED_SET_RESPONSE = 'NEWS_FEED_SET_RESPONSE';
export const NEWS_FEED_SELECTED = 'NEWS_FEED_SELECTED';
export const NEWS_FEED_RESET_SELECTED = 'NEWS_FEED_RESET_SELECTED';
export const NEWS_FEED_SET_FOLLOW_STATUS = 'NEWS_FEED_SET_FOLLOW_STATUS';
export const NEWS_FEED_SET_SEARCH_KEY_WORDS = 'NEWS_FEED_SET_SEARCH_KEY_WORDS';
export const NEWS_FEED_CLEAR_ITEMS = 'NEWS_FEED_CLEAR_ITEMS';
// Modals
export const SHOW_POPUP = 'SHOW_POPUP';
export const CLOSE_POPUP = 'CLOSE_POPUP';

// Report Page
export const REPORT_PAGE_UPDATE_KEYWORD = 'REPORT_PAGE_UPDATE_KEYWORD';



// WEBPACK FOOTER //
// ./app/constants/ACTION_TYPES.ts